import { getPromise, postPromise } from "@app/backend";

export interface CostingPayload {
	costingDetails: Record<string, unknown>;
}

export interface CostingResponse {
	message: string;
}

export function getBlastProducts(subDomainId: number) {
	return getPromise(
		`api/v2/get_blast_products?subdomain_id=${subDomainId}`,
		(data) => data || null
	);
}

// TODO
export function createCosting(costingDetails: CostingPayload) {
	return postPromise<CostingResponse, CostingResponse>(
		`api/dashboards/create_costing_details`,costingDetails,
		(data) => data || null
	);
}
